import Cookies from 'js-cookie'

export const getCookie = (key: string) => Cookies.get(key)
